// extracted by mini-css-extract-plugin
export var actionButton = "_dc-t";
export var buttonContainer = "_dc-0";
export var buttonContainer2 = "_dc-1";
export var buttonSection = "_dc-2";
export var details = "_dc-3";
export var dropdownItem = "_dc-5";
export var dropdownItemsContainer = "_dc-4";
export var fileInput = "_dc-r";
export var headerButton = "_dc-6";
export var icon = "_dc-7";
export var input = "_dc-8";
export var macroListItem = "_dc-9";
export var mainContent = "_dc-a";
export var microText = "_dc-b";
export var modal = "_dc-w";
export var optionsButton = "_dc-c";
export var paperclip = "_dc-s";
export var pillContent = "_dc-d";
export var preview = "_dc-e";
export var preview2 = "_dc-f";
export var quillEditor = "_dc-q";
export var selectedMacro = "_dc-g";
export var sidebar = "_dc-h";
export var sidebarHeader = "_dc-j";
export var sidebarList = "_dc-i";
export var sidebarListItem = "_dc-k";
export var sidebarSearch = "_dc-l";
export var snoozeDurationWrapper = "_dc-v";
export var statusPillContainer = "_dc-m";
export var tagsContainer = "_dc-n";
export var unselectedMacro = "_dc-o";
export var variable = "_dc-u";
export var wrapper = "_dc-p";